import { render, staticRenderFns } from "./base-file-picker.component.vue?vue&type=template&id=004a3fa0&scoped=true"
import script from "./base-file-picker.component.ts?vue&type=script&lang=ts&external"
export * from "./base-file-picker.component.ts?vue&type=script&lang=ts&external"
import style0 from "./base-file-picker.component.vue?vue&type=style&index=0&id=004a3fa0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004a3fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004a3fa0')) {
      api.createRecord('004a3fa0', component.options)
    } else {
      api.reload('004a3fa0', component.options)
    }
    module.hot.accept("./base-file-picker.component.vue?vue&type=template&id=004a3fa0&scoped=true", function () {
      api.rerender('004a3fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/base-file-picker/base-file-picker.component.vue"
export default component.exports